module.exports = __webpack_public_path__ + "files/6943fb6fd4200f3d073469325c6acdc9.ttf";


//////////////////
// WEBPACK FOOTER
// ./fonts/open-sans-v13-latin-ext_latin_cyrillic-ext_greek-ext_greek_cyrillic_vietnamese-300italic.ttf
// module id = 1577
// module chunks = 60